import { SubprojectCommentParams } from '@/features/projects/create-subproject/hooks/use-subproject-comments';
import { supabase } from '@/lib/supabase';
import { SubprojectCommentWithAuthor } from '@/shared/types/api';

export const getSubprojectComments = async (
  subprojectCommentParams: SubprojectCommentParams,
): Promise<SubprojectCommentWithAuthor[]> => {
  const { data, error } = await supabase
    .from('subproject_comment')
    .select('*, author: profiles!inner(*)')
    .eq('subproject_client_view_id', subprojectCommentParams.clientViewId)
    .eq(
      'subproject_contractor_view_id',
      subprojectCommentParams.contractorViewId,
    )
    .order('created_at', { ascending: true });

  if (error) throw error;

  return data;
};

export const addSubprojectComment = async (
  subprojectCommentParams: SubprojectCommentParams,
  message: string,
  authorProfileId: string,
) => {
  const { data, error } = await supabase.from('subproject_comment').insert({
    subproject_client_view_id: subprojectCommentParams.clientViewId,
    subproject_contractor_view_id: subprojectCommentParams.contractorViewId,
    message,
    author_profile_id: authorProfileId,
    seen: false,
    view_type: subprojectCommentParams.type,
  });

  if (error) throw error;

  return data;
};

export const deleteSubprojectComment = async (commentId: number) => {
  const { data, error } = await supabase
    .from('subproject_comment')
    .delete()
    .eq('id', commentId);

  if (error) throw error;

  return data;
};

export const updateSubprojectCommentSeen = async (commentId: number) => {
  const { data, error } = await supabase.rpc('set_comment_seen', {
    p_comment_id: commentId,
  });

  if (error) throw error;

  return data;
};
